import { AppData, Lightning, Utils } from "@lightningjs/sdk";
import { ItemNode } from "../lib/components/grid/ItemNode";
import { AppSetup } from "../lib/app-setup";
import { AppApiConfig } from "../lib/app-api-config";
import { Helper } from "../lib/helper";

export default class LableButton extends Lightning.Component {
  action: any;
  override _setup() {}

  static override _template() {
    return {      
      w: (w: any) => w, 
      h: (h: any) => h, 
      rect: true,
      color: controlsBGColor,
      shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },            
      Label: {
        x: (w: any) => w / 2,
        y: (h: any) => h / 2 + 5,
        mount: 0.5,
        text: {
          textColor: textBGColor,
          text: "",
          fontSize: 32,
          fontFace: 'Black',
          // letterSpacing: 0.82,  
        },
      },
      Stroke: {
        x: -2,
        y: -2,
        w: (w) => w + 4,
        h: (h) => h + 4,
        rect: true,
        color: 0x000000,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 6,
          stroke: 4,
          strokeColor: 0xffffffff
        }
      }
    };
  }

  set index(v: any) {
    this.x = v * 70;
  } 

  set label(v: any) {    
    if (v) {
      this.tag("Label").text.text = v;
    }
  }

  override _init() {
    const { appState } = AppData as AppSetup;
    const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
    this.textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
  }

  override _handleEnter() {
    this.action && this.fireAncestors(this.action);
  }

  override _focus() {
    this.tag('Stroke').shader.strokeColor = textBGColor;
    this.setSmooth("color", this.textfocuscolor);
    this.tag("Label").text.textColor = textBGColorFocus; 
  }

  override _unfocus() {
    this.tag('Stroke').shader.strokeColor = textBGColor
    this.setSmooth("color", controlsBGColor);
    this.tag("Label").text.textColor = textBGColor;
  }


  // _handleHover(target) {
  //   console.log('Layout-button: _handleHover:', target)
  //   this._focus()
  // }

  // _handleUnhover(target) {
  //   console.log('Layout-button: _handleUnover:', target)
  //   this._unfocus()
  // }

  get label() {
    return this.tag("Label").text.text;
  }
}
//const controlsBGColorFocus = 0xfff34966;
const controlsBGColorFocus = 0xffff0000;
//const controlsBGColor = 0xaa2c2c2c;
const controlsBGColor = 0xff000000;


const textBGColor = 0xffffffff;
const textBGColorFocus = 0xffffffff;
//d2d2d2
